// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e8cd615a","453":"a2c16762","455":"1b7ec826","977":"0767238c"}[chunkId] + ".chunk.js";
};